import { graphql, HttpResponse } from 'msw'
import {
  CashEquivalentCategory,
  type UpdateInvestmentCashEquivalentCategoriesOutput,
  type InvestmentCashEquivalentCategoriesRecommendationOutput,
} from '../../../models'

export const investmentCashEquivalentCategoriesRecommendation: InvestmentCashEquivalentCategoriesRecommendationOutput =
  {
    recommended: CashEquivalentCategory.TRIPLE_TAX_FREE,
    current: CashEquivalentCategory.TRIPLE_TAX_FREE,
    allowTripleTaxFreeMunicipalMutualFund: true,
  }

export const mockInvestmentCashEquivalentCategoriesRecommendation = graphql.query(
  'investmentCashEquivalentCategoriesRecommendation',
  () => {
    return HttpResponse.json({ data: { investmentCashEquivalentCategoriesRecommendation } })
  },
)

export const updateCashEquivalentCategories: UpdateInvestmentCashEquivalentCategoriesOutput = {
  __typename: 'InvestmentCashEquivalentConfig',
  cashEquivalentCategory: CashEquivalentCategory.NATIONAL,
}

export const mockInvestmentCashEquivalentAllocationUpdate = graphql.mutation('updateCashEquivalentCategories', () => {
  return HttpResponse.json({ data: { updateCashEquivalentCategories } })
})

export const mockCashEquivalentSector = [
  mockInvestmentCashEquivalentCategoriesRecommendation,
  mockInvestmentCashEquivalentAllocationUpdate,
]
